import { LogoInstance, TextInstance } from '../types/index';

/**
 * Sort instances by explicit layerOrder.
 * Defaults to descending (highest layerOrder first) which aligns with the Layers Panel visually.
 * For rendering/SVG generation, reverse to ascending so that higher layers are drawn last.
 */
export function sortInstancesByLayerOrder(
    logoInstances: LogoInstance[],
    textInstances: TextInstance[],
    direction: 'asc' | 'desc' = 'asc'
) {
    const allItems = [
        ...logoInstances.map(l => ({ type: 'logo' as const, data: l, layerOrder: l.layerOrder || 0 })),
        ...textInstances.map(t => ({ type: 'text' as const, data: t, layerOrder: t.layerOrder || 0 })),
    ];

    return allItems.sort((a, b) => {
        if (direction === 'asc') {
            return a.layerOrder - b.layerOrder;
        } else {
            return b.layerOrder - a.layerOrder;
        }
    });
}
